import React from 'react';
import { Link } from 'react-router-dom';

// Styles
import styles from "./../StaffManagment.module.css";

// Images
import arrowBlue from "./../../../../assets/img/DashboardICons/ArrowLeftBlue.svg";

const StaffSupportCard = (props) => {

    const staffSupportCardBox = (data) => {
        return (
            <div
                key={data.id}
                style={{ width: props.startNewMessage ? "48.5%" : "100%" }}
                className={`position-relative d-flex align-items-center justify-content-start flex-wrap mt-3 mb-2 p-3 ${styles.total_staff_support_card_box}`}
            >

                {
                    props.startNewMessage
                        ? null
                        : <i style={{ backgroundColor: data.status === "online" ? "#127442" : data.status === "offline" ? "#DEDEDE" : "" }} className={`position-absolute top-50 end-0 ${styles.status_staff_support_card_box}`}></i>
                }

                <img className={`${styles.image_staff_card_box}`} src={`https://backdev.azrmelk.com${data.imageUrl}`} alt="user-profile" style={{ borderRadius: "50%" }} />

                <div className={`d-flex align-items-center justify-content-start`}>
                    <span className={`pe-4 mb-0 ${styles.title_staff_card_box}`}> {data.name + " " + data.family} </span>
                    <span style={{ color: "#8D8D8D" }} className={`pe-2 mb-0 ${styles.subTitle_staff_card_box}`}> {data.areaRole} </span>
                </div>

                <span style={{ color: data.statusMessage === "پاسخ داده شده" ? "#515151" : "#127442" }} className={`me-md-auto me-sm-0 ${styles.status_message_staff_support_card_box}`}>
                    {data.statusMessage}
                </span>

                <Link to={{
                    pathname: props.startNewMessage ? `/staff-managment-support-message-detail/${data.userId}` : `/staff-managment-support-card-detail/${data.id}`,
                    state: data
                }} className={`ms-2 me-auto ${styles.link_icon_text}`}>
                    {
                        props.startNewMessage
                            ? ""
                            : "مشاهده"
                    }
                    <img className='me-2' src={arrowBlue} alt="arrow-blue-icon" width="15" />
                </Link>

            </div>
        )
    }

    return (
        <>
            <div dir="rtl" className={`text-right mx-4 px-2 pt-2 pb-3 mt-2 mb-3`}>
                <div className={`d-flex align-items-start justify-content-between flex-wrap`}>
                    {
                        props.startNewMessage
                            ? (
                                props.newStaffSupportMessage?.map(data => staffSupportCardBox(data))
                            ) : (
                                props.staffSupportMessageData?.map(data => staffSupportCardBox(data))
                            )
                    }
                </div>
            </div>
        </>
    )
}

export default StaffSupportCard;
